import type { ProviderToolDef } from "../types";
import type { FollowController } from "../follow/types";
import type { ConfirmationController } from "../confirmation/types";

export type SkillContext = {
  router: {
    push: (url: string) => void;
    replace: (url: string) => void;
  };
  accessToken: string | undefined;
  /** Controlador para feedback visual en modo follow. Llamadas son no-op
   *  cuando follow.enabled === false. */
  follow: FollowController;
  /** Controlador para pedir confirmación al usuario antes de acciones
   *  de escritura. Las skills CRUD DEBEN llamar a confirmation.confirm()
   *  antes de ejecutar la mutación. */
  confirmation: ConfirmationController;
};

export type SkillResult =
  | { ok: true; result: unknown; humanSummary?: string }
  | { ok: false; error: string };

export type Skill = {
  /** ID único — usado como nombre de la tool en el LLM. */
  id: string;
  /** Descripción visible al LLM (le ayuda a decidir cuándo usarla). */
  description: string;
  /** JSON Schema de los parámetros. */
  schema: {
    type: "object";
    properties: Record<string, unknown>;
    required?: string[];
  };
  /** Ejecuta la skill. Debe ser idempotente cuando posible. */
  run(args: Record<string, unknown>, ctx: SkillContext): Promise<SkillResult>;
};

export function skillToToolDef(skill: Skill): ProviderToolDef {
  return {
    type: "function",
    function: {
      name: skill.id,
      description: skill.description,
      parameters: skill.schema,
    },
  };
}
